import { AuthenticationResult, EventType } from "@azure/msal-browser";
import React, { createContext, useEffect, useMemo, useState } from "react";
import { apiBaseUrl, get, post } from "@services/api.service";
import { AuthContext as AuthContextT } from "@typedef/index";
import axios from "axios";
import { decodeToken } from "react-jwt";
import { useLocalStorage } from "@hooks/useLocalStorage";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "@hooks/useNotification";
import { UserType } from "~/Utils";

export const AuthContext = createContext({} as AuthContextT);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser, removeUser] = useLocalStorage("panelUser", null);
  const [xAuthProvider, setxAuthProvider] = useLocalStorage("authProvider", "azure");
  const [isLoading, setIsLoading] = useState(false);
  const { instance, accounts } = useMsal();
  const { openToast } = useNotification();

console.log(user);

  const navigate = useNavigate();

  const verifyOtp = async (data: any) => {
    // api login here
    setIsLoading(true);
    post("userprofile/verify-otp", data)
      .then((res: any) => {
        const { token, refreshToken } = res.response.data;
        if (token) {
          const tokenDetails: any = decodeToken(token);
          axios
            .get(`${apiBaseUrl}/userprofile/access`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(({ data }: any) => {
              if (data.status === "OK") {
                setUser({
                  token,
                  refreshToken: refreshToken,
                  email: data.response.data.emailAddress,
                  access: data.response.data.access,
                  currency: data.response.data.currency,
                  role: data.response.data.role,
                });
                setxAuthProvider("azure");
                setTimeout(() => {
                  setIsLoading(false);
                  navigate(`/dashboard`);
                }, 100);
              }
            });
        }
      })
      .catch(() => {
        navigate(`/dashboard`);
        setIsLoading(false);
      });
  };

  const refreshProfile = async () => {};

  // call this function to sign out logged in user
  const logout = () => {
    if (xAuthProvider === "azure" && accounts && accounts[0]) {
      // instance
      //   .logoutPopup({ account: instance.getActiveAccount() })
      //   .then(() => {
      //     removeUser("user");
      //     window.location.reload();
      //   })
      //   .catch((e) => {
      //     openToast({ content: e, type: "error" });
      //   });
      let homeAccountId = accounts[0].homeAccountId;
      removeUser("user");
      removeUser("redirecTo");
      localStorage.setItem("imageKey", "null");
      localStorage.setItem("docVersionKey", "null");
      instance.logoutRedirect({
        account: instance.getAccountByHomeId(homeAccountId),
        postLogoutRedirectUri: "/auth/login",
      });
    } else {
      removeUser("user");
      removeUser("redirecTo");
      window.location.reload();
    }
  };

  const value: AuthContextT = useMemo(
    () => ({
      user,
      logout,
      refreshProfile,
      isLoading,
      verifyOtp,
    }),
    // eslint-disable-next-line
    [user, isLoading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
